import { render } from "./Meals.vue?vue&type=template&id=7c97ca90"
import script from "./Meals.vue?vue&type=script&lang=js"
export * from "./Meals.vue?vue&type=script&lang=js"

import exportComponent from "/data/home/geraldo/git/Intmain/lowcarb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__